import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { FormControl, FormArray, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { sum, get } from 'lodash-es';
import { debounceTime } from 'rxjs/operators';
import { PurchaseModel } from '../purchase-model';

@Component({
  selector: 'app-cost-table',
  templateUrl: './cost-table.component.html',
  styleUrls: ['./cost-table.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class CostTableComponent implements OnInit {

  @Input('form') form:FormGroup;
  products:FormArray;
  paymentCurrency:FormControl;
  taxRate:FormControl;
  data:any;

  protected subscriptions = new Subscription();
  constructor(
    protected purchase:PurchaseService,
    protected cdRef:ChangeDetectorRef,
    @Inject(LOCALE_ID) public localeId:string,
  ) { 
  }

  ngOnInit(): void {
    this.products = this.form.get('products') as FormArray;
    this.paymentCurrency = this.form.get('paymentCurrency') as FormControl;
    this.taxRate = this.form.get('taxRate') as FormControl;
    this.subscriptions.add(
      this.products.valueChanges
      .pipe(debounceTime(100))
      .subscribe((v)=>{
        this.data = this.buildData();
        this.cdRef.detectChanges();
      })
    );  
  }
  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }

  get monthly_price_amount ():number {
    return sum(this.products.controls.map(productFormGroup=>{
      const product_id = get(productFormGroup.value, ['productId']);
      const quantity = get(productFormGroup.value, ['quantity']);
      if (!product_id) return 0;
      const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (!product_info) return 0;
      const {price_amount, expires } = product_info;
      if (!expires) return 0;
      const price_amount_with_currency = (get(price_amount, [this.paymentCurrency.value]) || 0);
      return price_amount_with_currency * quantity;
    })) * (1 + this.taxRate.value);
  }
  get none_monthly_price_amount ():number {
    return sum(this.products.controls.map(productFormGroup=>{
      const product_id = get(productFormGroup.value, ['productId']);
      const amount = get(productFormGroup.value, ['amount']);
      const quantity = get(productFormGroup.value, ['quantity']);
      if (!product_id) return 0;
      const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (!product_info) return 0;
      const {price_amount, expires } = product_info;
      if (expires) return 0;
      const price_amount_with_currency = (get(price_amount, [this.paymentCurrency.value]) || 0);
      return price_amount_with_currency * amount * quantity;
    })) * (1 + this.taxRate.value);
  }  
  get price_amount ():number {
    return sum(this.products.controls.map(productFormGroup=>{
      const product_id = get(productFormGroup.value, ['productId']);
      const amount = get(productFormGroup.value, ['amount']);
      const quantity = get(productFormGroup.value, ['quantity']);
      if (!product_id) return 0;
      const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (!product_info) return 0;
      const {price_amount} = product_info;
      const price_amount_with_currency = (get(price_amount, [this.paymentCurrency.value]) || 0);
      return price_amount_with_currency * amount * quantity;
    })) * (1 + this.taxRate.value);
  }
  get months ():number {
    const monthly_product_ctrl = this.products.controls.find(productFormGroup=>{
      const product_id = get(productFormGroup.value, ['productId']);

      const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (!product_info) return false;
      const { expires } = product_info;
      if (!expires) return false;

      return true;
    });
    if (!monthly_product_ctrl) return 0;
    return monthly_product_ctrl.get('amount').value;
  }


  buildData () {
    const model:PurchaseModel = this.form.value;
    if (!model.products || model.products.length === 0) return null;
    const data = {
      now:Date.now(),
      buyer_name:model.buyerInfo.groupName,
      group_name:model.buyerInfo.groupName,
      payment_type:model.paymentType,
      payment_currency:model.paymentCurrency,
      tax_rate:model.taxRate,
      items: model.products.map((product)=>{
        const productData = this.purchase.currentProducts.find(p=>p.product_id === product.productId);
        return {
          product_id:product.productId,
          amount:product.amount,
          quantity:product.quantity,
          starts_at: productData && productData.expires ? product.startsAt : null,
          expires_at: productData && productData.expires ? product.expiresAt : null,
          product:productData,
        };
      }),
      type:'school',
      extra_data:{
        group_name: model.buyerInfo.groupName,
        group_type: model.buyerInfo.groupType,
        // group_size: model.buyerInfo.groupSize,
        group_address: model.buyerInfo.groupAddress,
        // group_head_name: model.buyerInfo.groupHeadName,
        person_in_charge_email: model.personInCharge.personInChargeEmail,
        accountant_email: model.accountant && model.accountant.accountantEmail,
      },
      starts_at:model.products[0] && model.products[0].startsAt,
      expires_at:model.products[0] && model.products[0].expiresAt,
      comment:model.message,
      payment_amount: sum(model.products.map(product=>{
        const {amount, quantity} = product;
        const productData = this.purchase.currentProducts.find(p=>p.product_id === product.productId);
        if (!productData) return 0;
        const {price_amount} = productData;
        const price_amount_with_currency = (get(price_amount, [model.paymentCurrency]) || 0);
        return price_amount_with_currency * amount * quantity * (1 + this.taxRate.value);
      })) 
    }   
    return data;
  }

}
